import { render, staticRenderFns } from "./PaywallMenu.vue?vue&type=template&id=79e1ba94&scoped=true"
import script from "./PaywallMenu.vue?vue&type=script&lang=js"
export * from "./PaywallMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e1ba94",
  null
  
)

export default component.exports